import { render } from "./DeleteButton.vue?vue&type=template&id=3422d384&scoped=true"
import script from "./DeleteButton.vue?vue&type=script&lang=js"
export * from "./DeleteButton.vue?vue&type=script&lang=js"

import "./DeleteButton.vue?vue&type=style&index=0&id=3422d384&lang=scss&scoped=true"

import exportComponent from "/home/avangard/git/toode/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3422d384"]])

export default __exports__